import type {Suggestions} from '@github-ui/inline-autocomplete/types'
import {useQuery} from '@github-ui/react-query'
import {useMemo} from 'react'

import {useChatManager} from '../../utils/CopilotChatManagerContext'
import {IssueSuggestion} from './IssueSuggestion'

export interface IssuesQuery {
  category: 'issues'
  repository: string
  filter: string
}

export function useIssuesSuggestions(query: IssuesQuery | null) {
  const {service} = useChatManager()

  const issuesQuery = useQuery({
    enabled: query !== null,
    queryKey: ['copilot-autocomplete-issues', query?.repository, query?.filter],
    queryFn: async () => service.fetchAutocompleteIssues(query!.repository, query!.filter),
  })

  return useMemo<Suggestions | null>(() => {
    if (!query) return null

    if (issuesQuery.isLoading) return 'loading'

    return (
      issuesQuery.data?.map(issue => ({
        value: `${query.repository}/issues/${issue.number}`,
        key: issue.number.toString(),
        render: props => <IssueSuggestion {...props} issue={issue} />,
      })) ?? null
    )
  }, [issuesQuery.data, issuesQuery.isLoading, query])
}
